import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import apiJunction from "../../adapters/api";
import StrapiApiEndPoints from "../../config/StrapiApiEndPoints";
import Config from "../../config/app.config.json";

type InitialState = {
    warrantyData: any;
    errorWarrantyData: any;
};

const initialState: InitialState = {
    warrantyData: null,
    errorWarrantyData: null
};

// Generates pending, fulfilled and rejected action types
export const warrantyContent = createAsyncThunk(
    "terms/warrantyContent",
    () => {
        return apiJunction.makeRequest({
            method: "get",
            url: `/${Config.Warranty.WarrantyPolicy.template}${StrapiApiEndPoints.warranty}`,
            isStrapiApi: true,
        });
    }
);

const strapiWarrantySlice = createSlice({
    name: "warranty",
    initialState,
    reducers: {},
    extraReducers: (builder: any) => {
        builder.addCase(
            warrantyContent.fulfilled,
            (state: InitialState, action: PayloadAction<any>) => {
                state.warrantyData = action?.payload?.data?.data?.attributes;
                state.errorWarrantyData = null;
            }
        );
        builder.addCase(warrantyContent.rejected, (state: InitialState, action: any) => {
            state.warrantyData = null;
            state.errorWarrantyData = action.error || "Something went wrong";
        });
    },
});

export default strapiWarrantySlice.reducer;